<template>
  <ac-layout-form v-if="canRender" title="申请解除" @back="back">
    <Slogan theTitle="基本信息" />
    <van-cell-group>
      <div class="fd-input-info">
        <div ref="jcbqjbxx">
          <van-field
            class="text-right"
            v-model="formData.cSqfymc"
            required
            clearable
            readonly
            label="选择法院"
            right-icon="arrow"
            placeholder="请选择申请法院"
            @click="selectCourtBq"
          ></van-field>
          <van-field
            v-model="formData.cAh"
            required
            clearable
            readonly
            border
            input-align="right"
            label="案号"
          ></van-field>
          <van-field-checkbox
            label="申请人"
            placeholder="请选择申请人"
            required
            readonly
            v-model="formData.cSqrxmMultiple"
            :columns="sqrList"
            :isSearch="false"
            :option="{ label: 'sqrmc', value: 'cId' }"
          />
          <van-field
            v-model="formData.cJcbqsyText"
            required
            readonly
            label="解除保全事由"
            right-icon="arrow"
            input-align="right"
            placeholder="请选择解除保全事由"
            @click="showSyPicker = true"
          ></van-field>
          <van-popup v-model="showSyPicker" position="bottom">
            <van-picker
              value-key="text"
              :columns="codeList_804000"
              show-toolbar
              :default-index="0"
              @cancel="showSyPicker = false"
              @confirm="onSyConfirm"
            >
              <template #option="option">
                <div
                    style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  {{ option.name }}
                </div>
              </template>
            </van-picker>
          </van-popup>
          <van-field
            v-model="formData.cTjrlxText"
            required
            readonly
            label="提交人身份"
            right-icon="arrow"
            input-align="right"
            placeholder="请选择提交人身份"
            @click="showTJRLX = true"
          ></van-field>
          <van-popup v-model="showTJRLX" position="bottom">
            <van-picker
              show-toolbar
              :columns="columnTJRLX"
              :default-index="0"
              @cancel="handlerPicker('showTJRLX', false)"
              @confirm="onConfirmTJRLX"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.dtCreatetime"
            readonly
            border
            input-align="right"
            label="创建申请日期"
          ></van-field>
          <van-field
            v-model="formData.cBz"
            type="textarea"
            rows="2"
            show-word-limit
            autosize
            clearable
            border
            input-align="right"
            label="备注"
            maxlength="200"
            placeholder="请输入备注"
          ></van-field>
        </div>
        <!--财产线索-->
        <div v-if="nBqlx == '1'">
          <info-title
            title-content="财产线索"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqCcxs"
              ></van-icon>
            </template>
          </info-title>
          <!--                    {{bqCcxsxxs}}==={{jcbqccxsData}}-->
          <van-swipe-cell v-for="(item, index) in bqCcxsxxs" :key="item.cId">
            <van-cell
              title="财产类型"
              :value="item.cCclxText"
              :key="item.cId"
              @click="goToAddBqCCXS(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqCCXS(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>
        <!--证据信息-->
        <!--                {{bqZjxx}}==={{jcbqzjxxData}}-->
        <div v-if="nBqlx == '2'">
          <info-title
            title-content="证据信息"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqZjxx"
              ></van-icon>
            </template>
          </info-title>
          <van-swipe-cell v-for="(item, index) in bqZjxx" :key="item.cId">
            <van-cell
              title="证据类型"
              :value="item.nZjlxTxt"
              :key="item.cId"
              @click="goToAddBqZjxx(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqZjxx(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>
        <!--行为信息-->
        <div v-if="nBqlx == '3'">
          <info-title
            title-content="行为信息"
            required-description="必填"
            vertical-line="true"
          >
            <template slot="icon">
              <van-icon
                slot="right-icon"
                name="plus"
                style="line-height: inherit; float: right"
                @click="addBqXwxx"
              ></van-icon>
            </template>
          </info-title>
          <!--&lt;!&ndash;                    {{jcbqxwxxData}}=={{bqXwxx}}&ndash;&gt;{{bqXwxx}}-->
          <van-swipe-cell v-for="(item, index) in bqXwxx" :key="item.cid">
            <van-cell
              title="行为类型"
              :value="item.nXwbqsxTxt"
              :key="item.cId"
              @click="goToAddBqXwxx(item, item.cId)"
              is-link
            ></van-cell>
            <template slot="right">
              <div class="delete-btn" @click="deleteBqXwxx(item.cId, index)">
                删除
              </div>
            </template>
          </van-swipe-cell>
        </div>
        <Slogan theTitle="上传材料" />
        <div class="fd-upload-box">
          <van-field
            class="van-field--column van-field--no-value"
            required
            readonly
          >
            <template slot="label">
              <span>解除保全申请书</span>
            </template>
          </van-field>
          <!-- <p class="fd-com-warning-tip" v-text="mbxzts"></p> -->
          <!-- 上传组件 -->
          <ac-upload-file
            v-model="sqsclList"
            :upload-param="uploadFileParam"
            :upload-url="uploadFileUrl"
            :get-upload-file-data="getUploadFileData"
            :delete-url="deleteFileUrl"
            :delete-param="getDeleteFileParam"
          ></ac-upload-file>
        </div>
        <div class="fd-upload-box">
          <van-field class="van-field--column van-field--no-value" readonly>
            <template slot="label">
              <span>其他材料</span>
            </template>
          </van-field>
          <ac-upload-file
            v-model="sqsclListQtcl"
            :upload-param="uploadFileParamQtcl"
            :upload-url="uploadFileUrl"
            :get-upload-file-data="getUploadFileData"
            :delete-url="deleteFileUrl"
            :delete-param="getDeleteFileParam"
          ></ac-upload-file>
        </div>
      </div>
    </van-cell-group>

    <template slot="footer">
      <van-button
        class="guarantee-button"
        type="info"
        size="normal "
        round
        plain
        @click="back"
      >
        取消
      </van-button>
      <van-button
        class="guarantee-button submit-btn"
        type="info"
        size="normal"
        round
        @click="saveBqReile"
      >
        提交
      </van-button>
    </template>
  </ac-layout-form>
</template>

<script>
import Slogan from "@/components/common/slogan";
import vanFieldCheckbox from "@/components/common/vanFieldCheckbox";
// 表单布局
import acLayoutForm from "@/components/app/layout/form/index.vue";
// 上传文件
import acUploadFile from "@/components/app/continuation-upload-file/index.vue";
import validate from "../../utils/validator/validator";
import InfoTitle from "../../components/common/InfoTitle";
import { columnsTJR } from "../../utils/option.js";
import {
  jcbqYyRule,
  jcbqSqsRule,
  ssygRule,
  tjrsfRule,
  jcxxbqCcxsListRule,
  jcxxbqZjxxListRule,
  jcxxbqXwxxListRule,
} from "../../utils/validator/rules";
import { mbxzts } from "../../utils/consts";
import { mapGetters } from "vuex";
import { createId } from "@/utils/common";
import {
  saveJcbqData,
  getJcbqScclList,
  submitJcbqData,
} from "../../api/guarantee";
import request from "@/api/axios";
import { getSqrList, getJcbqxx } from "@/api/guarantee";
import { typeCclx, typeXwbqsx, zjlxType, typeTjrlx } from "@/filters";
import { Notify } from "vant";
import { dateFormat } from "@/utils/dateFormatter";
import {getCode} from "@/api/common";
export default {
  components: {
    acLayoutForm,
    acUploadFile,
    Slogan,
    vanFieldCheckbox,
    InfoTitle,
  },
  data() {
    return {
      cBqlb: "",
      currentDate: new Date(),
      userAssign: [],
      // checkboxRefs: [],
      // 申请人
      showPickerCheckbox: false,
      // 是否是法院选择页面跳转过来的
      isFormselectBqCourtJc: false,
      bqCcxsxxs: [],
      // 证据信息
      bqZjxx: [],
      bqXwxx: [],
      nBqlx: "",
      bqjbxxData: [],
      formData: {
        cAh: null,
        cBqid: null,
        cBqId: null,
        cBz: "",
        cId: null,
        cJcbqsy: "",
        cJcbqsyText:"",
        cSqfy: null,
        cSqfymc: null,
        cSqrids: "",
        cSqrmcs: "",
        cSqrxmMultiple: [],
        cTjrsf: "",
        dtCreatetime: "",
        cTjrlxText: "申请人",
        cAhdm:null,
      },
      postData: {
        // 获取路由中的保全id参数
        cBqid: this.$route.query.bqid,
        // 获取路由中的申请编号参数
        // cSqbh: this.$route.query.sqbh,
        cSqfymc: "",
        cSqsid: "",
        cTjid: "",
        cJcbqsy: "",
      },
      // 申请书材料列表
      sqsclList: [],
      // 其他材料列表
      sqsclListQtcl: [],
      sqrList: [],
      mbxzts: mbxzts,
      showSyPicker: false,
      // 上传文件url
      uploadFileUrl: "ssbq/api/ssbq/jc/upload",
      // 删除文件url
      deleteFileUrl: "ssbq/api/ssbq/jc/deletefile",
      // 材料类型
      cllx: 1,
      // 是否可以渲染
      canRender: false,
      columnTJRLX: columnsTJR,
      showTJRLX: false,
      saveFlag:false,
      codeList_804000:[]
      // 申请人
      // cSqrmcsText: '',
      // cSqrmcsList: [],
    };

  },
  computed: {
    ...mapGetters([
      "codeList_804000",
      "jcbqxwxxData",
      "jcbqccxsData",
      "jcbqzjxxData",
    ]),
    // 上传的请求参数
    uploadFileParam() {
      return {
        // 保全id
        cllx: 1,
        bqid: this.$route.query.bqid,
        jbid: this.$route.query.cId,
      };
    },
    // 删除文件的请求参数
    deleteFileParam() {
      return {
        time: new Date().getTime(),
      };
    },
    // 其他材料上传的请求参数
    uploadFileParamQtcl() {
      return {
        cllx: 255,
        bqid: this.$route.query.bqid,
        jbid: this.$route.query.cId,
      };
    },
  },
  created() {
    this.cBqlb = sessionStorage.getItem("cBqlb");
    this.nBqlx = sessionStorage.getItem("cBqlx");
    // 请求解除保全事由
    this.$store.dispatch("GetCodeType", 804000);
    getCode({ codetype: 804000 }).then((res) => {
      this["codeList_804000"] = res.data;
    });
    // 初始化被申请人
    this.initBqSqrs();
    // 请求对应的id
    this.gainId();
    this.getData();
    this.GetSQRList({ bqid: this.$route.query.bqid });
  },
  watch: {
    "formData.cSqrxmMultiple"(selectList) {
      if (selectList && selectList.length > 0) {
        this.formData.cSqrids = selectList.join(",");
        this.formData.cSqrmcs = this.sqrList
          .filter((i) => selectList.includes(i.cId))
          .map((mc) => mc.sqrmc)
          .join(",");
      }
    },
  },
  methods: {
    /**
     * 获取上传文件数据
     * @returns {Object} 文件数据
     * */
    getUploadFileData(data, fileData) {
      return {
        // 申请材料id
        cId: data.cId,
        ...fileData,
      };
    },
    /**
     * 获取删除文件的参数
     * @param {Object} fileData 文件数据
     * @returns {Object} 请求参数对象
     * */
    getDeleteFileParam(fileData) {
      return {
        // 请求id
        id: fileData.id,
        // 材料类型
        cllx: fileData.cllx,
      };
    },

    /* 操作选择弹层 */
    handlerPicker(name, type) {
      /* 选择保全类型和保全类别需要先提示选择法院 */
      if (
        (name === "showBQLX" ||
          name === "showPicker" ||
          name === "showPickerBxgs") &&
        !this.formData.cFymc
      ) {
        Notify({ type: "danger", message: "请先选择法院" });
        return;
      }

      this[name] = type;
    },
    onConfirmTJRLX(item) {
      // this.formData.cTjrsf = item.text;
      this.formData.cTjrlxText = item.text;
      this.formData.cTjrsf = item.keyId;
      this.showTJRLX = false;
    },
    // 获取申请人列表
    GetSQRList(params) {
      return new Promise((resolve, reject) => {
        getSqrList(params)
          .then((response) => {
            // let {data} = response
            console.log(response);
            // commit('SET_SQRLIST', data)
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    selectCourtBq() {
      this.$router.push({
        path: "/selectBqCourtJc",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 添加财产线索
    addBqCcxs() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("jcInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log("222222========", formData.dtCreatetime);
      sessionStorage.setItem("jcbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqCcxsId", "");
      this.onSubmit();
      this.$router.push({
        path: "/JcaddBqCcxs",
        query: {
          cId: this.$route.query.cId,
          bqid: this.$route.query.bqid,
        },
      });
    },
    // 添加证据信息
    addBqZjxx() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("jcInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      sessionStorage.setItem("jcbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqZjxxId", "");
      this.onSubmit();
      this.$router.push({
        path: "/JcaddBqZjxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    /**
     * 请求数据
     * @param {Object} params 请求参数
     * */
    requestData(params) {
      return this.$axios.get("ssbq/api/bqsqinfo", params);
    },
    params() {
      let formData = JSON.parse(this.formData);
      let jbCcxxs = [];
      let jbXwxxs = [];
      let jbZjxxs = [];
      if (this.nBqlx == "1") {
        jbCcxxs = this.jcbqccxsData;
      }
      if (this.nBqlx == "2") {
        jbZjxxs = this.jcbqzjxxData;
      }
      if (this.nBqlx == "3") {
        jbXwxxs = this.jcbqxwxxData;
      }
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      return {
        jbJbxx: formData,
        jbCcxxs: jbCcxxs,
        jbZjxxs: jbZjxxs,
        jbXwxxs: jbXwxxs,
      };
    },
    onSubmit(fn) {
      console.log("dbx===========", this.params());
      saveJcbqData(this.params())
        .then((res) => {
          console.log("--addXcxXw 123", res);
          if (res.code === 200) {
            this.$notify({ type: "success", message: "操作成功" });
          } else {
            this.$notify(res.message);
          }
          fn();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 行为信息
    addBqXwxx() {
      // 清空解保和续保init接口返回的数据
      sessionStorage.removeItem("jcInitData");
      let bqid = JSON.parse(sessionStorage.getItem("bqid"));
      sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
      console.log("111111111========", this.formData);
      // JSON.stringify转字符串,值为undefined被过滤处理的问题
      this.formData = JSON.stringify(this.formData, (key, value) =>
        // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
        typeof value === "undefined" ? "" : value
      );
      let formData = JSON.parse(this.formData);
      formData.dtCreatetime = this.currentDate;
      formData.dtCreatetime = dateFormat(
        formData.dtCreatetime,
        "yyyy-MM-dd hh:mm:ss"
      );
      sessionStorage.setItem("jcbqjbxx", JSON.stringify(formData));
      sessionStorage.setItem("bqXwxxId", "");
      this.onSubmit();
      this.$router.push({
        path: "/JcaddBqXwxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 财产线索
    goToAddBqCCXS: function (ccxsItem, ccxsId) {
      sessionStorage.setItem("jcccxsItem", JSON.stringify(ccxsItem));
      // sessionStorage.setItem("bqZjxxId", zjxxItem.cid);
      sessionStorage.setItem("bqCcxsId", ccxsId);
      this.$router.push({
        path: "/JcaddBqCCXS",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    // 证据信息
    goToAddBqZjxx: function (zjxxItem, cid) {
      sessionStorage.setItem("jczjxxItem", JSON.stringify(zjxxItem));
      sessionStorage.setItem("bqZjxxId", cid);
      this.$router.push({
        path: "/JcaddBqZjxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    goToAddBqXwxx: function (xwxxItem, cId) {
      sessionStorage.setItem("jcxwxxItem", JSON.stringify(xwxxItem));
      sessionStorage.setItem("bqXwxxId", cId);
      this.$router.push({
        path: "/JcaddBqXwxx",
        query: {
          bqid: this.$route.query.bqid,
          cId: this.$route.query.cId,
        },
      });
    },
    deleteBqCCXS: function (id, index) {
      this.bqCcxsxxs.splice(index, 1);
      console.log(this.bqCcxsxxs);
      this.jcbqccxsData.map((item, index) => {
        if (item.cId == id) this.jcbqccxsData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
      console.log(this.jcbqccxsData);
    },
    // 删除证据信息
    deleteBqZjxx: function (id, index) {
      this.bqZjxx.splice(index, 1);
      this.jcbqzjxxData.map((item, index) => {
        if (item.cid == id) this.jcbqzjxxData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
    },
    deleteBqXwxx: function (id, index) {
      this.bqXwxx.splice(index, 1);
      this.jcbqxwxxData.map((item, index) => {
        if (item.cid == id) this.jcbqxwxxData.splice(index, 1); //index 当前元素索引；1：需要删除的元素个数
      });
    },
    getBqZjxx(zjxxdata) {
      zjxxdata.map((item) => {
        this.bqZjxx.push({
          cId: item.cid,
          // 证据类型
          nZjlx: item.nZjlx,
          // nZjlx: zjlxType(item.nZjlx),
          // 证据类型
          nZjlxTxt: zjlxType(item.nZjlx),
          // 证据名称
          cZjmc: item.cZjmc,
          // 原件原物
          nYjwj: item.nYjwj,
          // 证据来源
          cZjly: item.cZjly,
          // 证据说明
          cSm: item.cSm,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    getBqXwxx(xwxxdata) {
      xwxxdata.map((item) => {
        this.bqXwxx.push({
          cId: item.cid,
          nXwbqsx: item.nXwbqsx,
          nXwbqsxTxt: typeXwbqsx(item.nXwbqsx),
          cSm: item.cSm,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    getBqCcxs(ccxsdata) {
      ccxsdata.map((item) => {
        this.bqCcxsxxs.push({
          cId: item.cId,
          cCclx: item.cCclx,
          cCclxText: typeCclx(item.cCclx),
          cMs: item.cMs,
          dBqksrq: item.dBqksrq,
          dBqjsrq: item.dBqjsrq,
        });
      });
    },
    initForm(res) {
      let data = res.data;
      // 利用es6的结构赋值拿出res.data中需要的数据项并赋给formData
      this.formData = (({
        cAh,
        cBqId,
        cBqid,
        cBz,
        cId,
        cJcbqsy,
        cSqfy,
        cSqfymc,
        cSqrids,
        cSqrmcs,
        cSqrxmMultiple,
        cTjrsf,
        dtCreatetime,
      }) => ({
        cAh,
        cBqId,
        cBqid,
        cBz,
        cId,
        cJcbqsy,
        cSqfy,
        cSqfymc,
        cSqrids,
        cSqrmcs,
        cSqrxmMultiple,
        cTjrsf,
        dtCreatetime,
      }))(data);
      // this.formData.cId = this.$route.params.id.split('-')[0]
      // this.formData.cBqId = this.$route.params.id.split('-')[1]
      this.formData.cBqId = sessionStorage.getItem("bqid");
      this.formData.cBqid = sessionStorage.getItem("bqid");
      this.formData.cId = this.$route.query.cId;
      let _this = this;
      this.codeList_804000.forEach(function (item) {
        if (item.code == _this.formData.cJcbqsy) {
          _this.formData.cJcbqsy = item.code;
          _this.formData.cJcbqsyText=item.name;
        }
      });
      this.formData.dtCreatetime = "";
      if (!this.formData.dtCreatetime) {
        this.formData.dtCreatetime = this.timeFormat(new Date());
      } else {
        this.formData.dtCreatetime = this.timeFormat(
          this.formData.dtCreatetime
        );
      }
      if (this.formData.cSqrmcs) {
        this.formData.cSqrxmMultiple = this.formData.cSqrids.split(",");
      }
      // if(!this.formData.cTjrsf){
      //     this.formData.cTjrsf = '1'
      // }
      // this.$nextTick(()=>{
      //     this.$refs.myForm.clearValidate()
      // })
    },
    async getData() {
      // 获取解除保全init接口拿回来的信息
      let jcInitData = JSON.parse(sessionStorage.getItem("jcInitData"));
      if (jcInitData) {
        this.initForm(jcInitData);
      } else {
        getJcbqScclList({ jbid: this.$route.query.cId }).then((res) => {
          console.log(res.data);
          this.sqsclList = res.data.sqs;
          this.sqsclListQtcl = res.data.qt;
        });
        // 获取解除保全基本信息
        await getJcbqxx({ id: this.$route.query.cId || "" })
          .then((res) => {
            this.initForm(res);
            let jccheckedFy = sessionStorage.getItem("jccheckedFy");
            if (jccheckedFy && this.isFormselectBqCourtJc) {
              this.formData.cSqfymc = jccheckedFy;
            }
            this.formData.cTjrlxText = typeTjrlx(this.formData.cTjrsf);
            this.formData.dtCreatetime = this.timeFormat(
              this.formData.dtCreatetime
            );
            console.log("获取基本信息", res.data);
            // Object.assign(this.jcbqjbxxData, res.data)
            let cBqlx = sessionStorage.getItem("cBqlx");
            if (cBqlx === "1") {
              this.$store
                .dispatch("GetJCBQCCXSList", {
                  jbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  this.getBqCcxs(res.data);
                  console.log("this.bqCcxsxxs===============", this.bqCcxsxxs);
                });
              // this.getBqCcxs();
            } else if (cBqlx == "2") {
              this.$store
                .dispatch("GetJCBQZJXXList", {
                  jbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  this.getBqZjxx(res.data);
                });
            } else if (cBqlx == "3") {
              this.$store
                .dispatch("GetJCBQXWXXList", {
                  jbid: this.$route.query.cId,
                  bqid: this.$route.query.bqid,
                })
                .then((res) => {
                  this.getBqXwxx(res.data);
                });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    timeFormat(currentTime) {
      // 时间格式化 2019-09-08
      let time = new Date(currentTime);
      let year = time.getFullYear();
      let month = this.showTime(time.getMonth() + 1);
      let day = this.showTime(time.getDate());
      return year + "-" + month + "-" + day;
    },
    // 封装一个不够两位数就补零的函数
    showTime(t) {
      let time;
      time = t >= 10 ? t : "0" + t;
      return time;
    },
    /**
     * 选择事由
     * @returns {void}
     * */
    onSyConfirm: function (code) {
      // 申请解保事由赋值
      this.formData.cJcbqsy = code.code;
      this.formData.cJcbqsyText = code.name;
      // 弹层隐藏
      this.showSyPicker = false;
    },

    /**
     * 请求解除保全
     * @returns {void}
     * */
    saveBqReile() {
      // 校验表单
      this.validateForm().then(() => {

        console.log("zxfwtoken========", localStorage.getItem('zxfwtoken'));
        if (localStorage.getItem('zxfwtoken')) {
          const paramsah = {
            fydm: this.formData.cSqfy,
            ah: this.formData.cAh,
            zxfwToken: localStorage.getItem('zxfwtoken')
          };
          this.$axios.get('ssbq/api/bqyzw/bqsq/ahdm', paramsah).then((res) => {
            if (res.code === 200) {
              this.formData.cAhdm = res.data;
              console.log('——————this.cAhdm：————————', this.formData.cAhdm);
              this.saveFlag=true;
            } else {
              const errorMessage ='案号代码获取失败,请重新尝试';
              this.$notify(errorMessage);
              this.saveFlag=false;
            }
          });
        } else {
          const errorMessage= '案号代码获取失败,请重新尝试';
          this.$notify(errorMessage);
          this.saveFlag=false;
        };
        if(this.saveFlag) {
          this.formData = JSON.stringify(this.formData, (key, value) =>
              // 使用三元表达式判断如果value是undefined就赋值为""否则还是value自身的值
              typeof value === "undefined" ? "" : value
          );
          let formData = JSON.parse(this.formData);
          formData.dtCreatetime = this.currentDate;
          formData.dtCreatetime = dateFormat(
              formData.dtCreatetime,
              "yyyy-MM-dd hh:mm:ss"
          );
          console.log("222222========", formData.dtCreatetime);
          //this.onSubmit();

          saveJcbqData(this.params())
              .then((res) => {
                console.log("--addXcxXw 123", res);
                if (res.code === 200) {
                  this.$notify({type: "success", message: "操作成功"});
                  // 申请解保事由
                  this.postData.cJcbqsy = this.formData.cJcbqsy;
                  // 提交（先暂存再提交）
                  submitJcbqData({jbid: this.$route.query.cId}).then((res) => {
                    if (res.code == 200) {
                      this.$router.push("/home/myRelievPreservation");
                    } else {
                      this.$message({
                        type: "warning",
                        message: res.message,
                      });
                    }
                  });
                } else {
                  this.$notify(res.message);
                }
                fn();
              })
              .catch((error) => {
                console.log(error);
              });
        }
      });
    },

    /**
     * 获取id
     * @returns {void}
     * */
    gainId() {
      // 创建对应的id
      createId().then((id) => {
        // 统计id
        this.tjid = id;
        this.postData.cTjid = id;
      });
    },

    /**
     * 初始化保全申请人
     * @returns {void}
     * */
    initBqSqrs() {
      this.$axios
        .get("ssbq/api/sqrs?bqid=" + this.postData.cBqid)
        .then((res) => {
          if (res.code == 200) {
            let sqrs = "";
            let sqrIds = "";
            res.data.forEach((item) => {
              let sqr = {};

              if (item.cSqrlx == "1") {
                sqr.sqrmc = item.cSqrxm;
                sqr.cId = item.cZjh;
              } else {
                sqr.sqrmc = item.cQymc;
                sqr.cId = item.cQyzzjgdm;
              }
              sqrs = sqrs.concat(sqr.sqrmc, "、");
              sqrIds = sqrIds.concat(sqr.cId, ",");
              this.sqrList.push(sqr);
              // this.formData.cSqrmcs = arr.join()
              this.showPickerCheckbox = false;
            });
            this.formData.cSqrmcs = sqrs.substring(0, sqrs.length - 1);
            this.postData.cSqrmcs = sqrIds.substring(0, sqrIds.length - 1);
          } else {
            this.$notify(res.message);
          }
        })
        .catch(function () {
          this.$notify("系统异常");
        });
    },

    /**
     * 请求删除申请材料
     * @param {Object} params 请求参数
     * @returns {Promise}
     * */
    requestDelSccl(params) {
      return request({
        url: "ssbq/api/sccls/bgsq/delsqcl",
        method: "delete",
        params: {
          time: new Date().getTime(),
          ...params,
        },
      });
    },

    /**
     * 点击返回，则调用取消解除保全
     * @returns {void}
     * */
    back() {
      // 如果上传材料，则需要进行相应的删除
      if (!this.sqsclList.length) {
        // 返回上一级
        history.go(-1);
        return;
      }
      // 删除上传材料再返回
      this.requestDelSccl({
        cDbid: "",
        isDeldbl: false,
        isDelsqs: false,
        // 变更id
        cBgid: this.tjid,
      })
        .then(() => {
          history.go(-1);
        })
        .catch(() => {
          this.$notify("系统异常");
        });
    },

    /**
     * 校验表单
     * @returns {Promise}
     * */
    validateForm() {
      console.log("=============", this.formData);
      let descriptor = {
        // 申请人
        // sqr: ssygRule,
        // 申请原因
        sqyy: jcbqYyRule,
        // 提交人身份
        tjrsf: tjrsfRule,
        // 财产、证据、行为必填
        ccxslist: this.nBqlx == "1" ? jcxxbqCcxsListRule : "",
        zjxxlist: this.nBqlx == "2" ? jcxxbqZjxxListRule : "",
        xwxxlit: this.nBqlx == "3" ? jcxxbqXwxxListRule : "",
        // 申请书材料 必填
        sqs: jcbqSqsRule,
      };
      const validated = validate(descriptor, {
        // 申请人
        // sqr: this.formData.cSqrxmMultiple,
        // 申请原因
        sqyy: this.formData.cJcbqsy,
        // 提交人身份
        tjrsf: this.formData.cTjrsf,
        // 财产、证据、行为必填
        ccxslist: this.nBqlx == "1" ? this.bqCcxsxxs : "",
        zjxxlist: this.nBqlx == "2" ? this.bqZjxx : "",
        xwxxlit: this.nBqlx == "3" ? this.bqXwxx : "",
        // // 申请书材料 必填
        sqs: this.sqsclList,
      });
      return validated;
    },
    sfType() {
      return function (value) {
        switch (value) {
          case "1":
            return "申请人";
          case "2":
            return "律师";
          case "3":
            return "其他代理人";
        }
      };
    },
  },
  //进入该页面时，刷新页面，要不上传会导致页面刷新
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "myPreservation") {
        // 如果是从保全列表过来的需要刷新下页面，否则在手机上上传会有问题
        window.location.reload();
      }
      let jccheckedFy = sessionStorage.getItem("jccheckedFy");
      if (from.name == "selectBqCourtJc" && jccheckedFy) {
        vm.$data.isFormselectBqCourtJc = true;
        vm.$data.formData.cSqfymc = jccheckedFy;
      }
      // 可以进行渲染
      vm.canRender = true;
    });
  },
  // 路由跳转之前保存当前滚动条的位置。
  // beforeRouteLeave(to, from, next) {
  //     sessionStorage.removeItem("jcInitData");
  //     // sessionStorage.removeItem("cDbxxId");
  //     next();
  // },
};
</script>

<style lang="less" scoped>
.delete-btn {
  width: 64px;
  height: 55px;
  background: #ee0a24;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  letter-spacing: 3px;
  text-align: center;
}
</style>
